module.exports = __webpack_public_path__ + "img/009-judge.57154c51.png";